class Storage {
  constructor() {
    this.type = 'local' // local or session
    this.version = '1.0.0'
  }

  set(key, data, ttl) {
    if (!this._isStr(key)) return
    const time = Date.now(),
      expire = Number(ttl) || 0,
      json = JSON.stringify({ time, expire, data })
    this.store.setItem(key, json)
  }

  get(key) {
    if (!this._isStr(key)) return
    const json = this.store.getItem(key) || '{}',
      parsed = JSON.parse(json) || {},
      { time, expire, data } = parsed
    if (this._isExpired(time, expire)) this.delete(key)
    return data
  }

  delete(key) {
    if (!this._isStr(key)) return
    this.store.removeItem(key)
  }

  clear(force = !1) {
    if (force) {
      this.store.clear()
    } else {
      const keys = Object.keys(this.store).filter((key) => key)
      keys.forEach((key) => this.delete(key))
    }
  }

  get store() {
    return this.type === 'local' ? localStorage : sessionStorage
  }

  _isStr(str) {
    return str && typeof str === 'string'
  }

  _isExpired(time, expire) {
    if (!time || !expire) return !1
    const now = Date.now(),
      secs = (now - time) / 1000
    return secs >= expire ? !0 : !1
  }
}

export default new Storage()
